/**
 * <TutorTrainingQuestion> — une question du quiz de formation, à répondre (molecule).
 *
 * La `QuestionCard` de l'ancien `TutorTrainingScreen` : le numéro et la question, puis ses réponses,
 * une seule à choisir. Les réponses sont les lignes du quiz de prérequis de l'élève
 * (`<QuizChoiceRow>`) : la lettre dans sa pastille, la choisie sur l'aplat de l'univers, et on peut
 * changer d'avis tant que le quiz n'est pas validé. Le quiz ne dit pas juste ou faux ici : la
 * correction vient avec le résultat.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"
import { QuizChoiceRow } from "../QuizChoiceRow"
import { quizChoiceLetter } from "../QuizChoiceRow/QuizChoiceRow"
import { type UITutorTrainingQuestion } from "../../../ports/primary/ui/types/tutorCompte"

export type TutorTrainingQuestionProps = {
    /** Sa place dans le quiz, à partir de 0. */
    index: number
    question: UITutorTrainingQuestion
    /** La réponse choisie. */
    selected?: string | null
    onSelect: (answer: string) => void
    /** L'envoi est parti : plus rien ne se touche. */
    disabled?: boolean
    testID?: string
}

export function TutorTrainingQuestion(props: TutorTrainingQuestionProps) {
    const { index, question, selected, onSelect, disabled = false, testID } = props

    return (
        <Card p="4" testID={testID}>
            <Stack gap="3">
                <Text weight="bold" color="primary">{`${index + 1}. ${question.text}`}</Text>
                <Stack gap="2">
                    {question.options.map((option, optionIndex) => (
                        <QuizChoiceRow
                            key={option}
                            letter={quizChoiceLetter(optionIndex)}
                            label={option}
                            state={selected === option ? "selected" : "idle"}
                            onPress={disabled ? undefined : () => onSelect(option)}
                        />
                    ))}
                </Stack>
            </Stack>
        </Card>
    )
}
